import { createContext, useCallback, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);
export const useSite = () => useContext(SiteCtx);

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function setSeo(title, description) {
  if (title) document.title = title;
  if (description !== undefined) setMeta("description", description);
}

function applyTheme(s) {
  const root = document.documentElement.style;
  Object.entries(s.brand?.colors || {}).forEach(([k, v]) => root.setProperty(`--bt-${k.replace(/_/g, "-")}`, v));
  const { heading = "Fraunces", body = "Figtree" } = s.brand?.fonts || {};
  root.setProperty("--font-heading", `"${heading}", Georgia, serif`);
  root.setProperty("--font-body", `"${body}", system-ui, sans-serif`);
  const fam = (f) => `family=${f.trim().replace(/ /g, "+")}:wght@400;500;600;700`;
  let link = document.getElementById("bt-fonts");
  if (!link) {
    link = document.createElement("link");
    link.id = "bt-fonts";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = `https://fonts.googleapis.com/css2?${fam(heading)}&${fam(body)}&display=swap`;
  const icon = document.querySelector("link[rel='icon']");
  if (icon && s.brand?.logo_url) icon.href = s.brand.logo_url;
  setSeo(s.seo?.title, s.seo?.description);
}

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const reload = useCallback(async () => {
    const { data } = await api.get("/settings");
    applyTheme(data);
    setSettings(data);
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  const value = useMemo(() => ({ settings, reload }), [settings, reload]);
  if (!settings)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="site-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#DCE3D3] border-t-[#0D3D26]" />
      </div>
    );
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}
